/* eslint-disable-next-line import/prefer-default-export */
export const Reporting = {
  search: (params, page = 1) => ({ url: '/reporting/forms/searches/new', params: { q: params, page: page } }),
  export: (params) => ({ url: '/reporting/forms/searches/export', params: { q: params } }),
  exportProtocols: (protocolID) => ({ url: `/protocols/${protocolID}/site_reporting/export` }),
  formTemplates: () => ({ url: '/reporting/form_templates' }),
};
